import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
      width: '100%',
      background: 'black',
    },
    root: {
      maxWidth: '328px !important',
      '& #outlined-basic': {
        padding: '15.5px 14px',
      },
      '& .MuiFormLabel-root': {
        color: '#909599',
        fontFamily: 'Proxima-Nova-Regular',
        fontSize: '16px',
        fontWeight: '500',
        lineHeight: '20px',
      },
      '& .MuiOutlinedInput-notchedOutline': {
        border: '1px solid #49494A !important',
        '&:focus': {
          backgroundColor: 'red',
          border: '1px solid #49494A',
        },
      },
      '& .MuiInputBase-input': {
        color: '#909599',
        fontFamily: 'Proxima-Nova-Regular',
        fontSize: '16px',
        fontWeight: '500',
        lineHeight: '20px',
      },
      '& label.MuiInputLabel-outlined:not(.MuiInputLabel-shrink)': {
        transform: 'translate(14px, 16px) scale(1)',
        color: '#909599',
        fontSize: '16px',
        fontFamily: 'Proxima-Nova-Regular',
        fontWeight: '500',
        letterSpacing: '0',
        lineHeight: '20px',
      },
      '& label.Mui-focused': {
        color: '#909599',
      },
    },
    imgWrapper: {
      display: 'flex',
      justifyContent: 'space-evenly',
      paddingBottom: '52px',
    },
    img: {
      width: '108px',
      height: '28px',
    },
    admin: {
      height: '28px',
      width: '119px',
      color: '#FFFFFF',
      fontFamily: 'ProximaNova-Light',
      fontSize: '39px',
      fontWeight: '300',
      lineHeight: '28px',
      textAlign: 'center',
      textTransform: 'uppercase',
    },
    emailField: {
      height: '47px',
      width: '100%',
      marginBottom: '21.5px',
    },
    passwordField: {
      marginBottom: '21.5px',
      height: '47px',
      width: '100%',
      '& #outlined-basic': {
        padding: '15.5px 14px',
      },
      '& .MuiFormLabel-root': {
        color: '#909599',
        fontFamily: 'Proxima-Nova-Regular',
        fontSize: '16px',
        fontWeight: '500',
        lineHeight: '20px',
      },
      '& .MuiOutlinedInput-notchedOutline': {
        border: '1px solid #49494A',
        '&:focus': {
          backgroundColor: 'red',
          border: '1px solid #49494A',
        },
      },
      '& .MuiInputBase-input': {
        color: '#909599',
        fontFamily: 'Proxima-Nova-Regular',
        fontSize: '16px',
        fontWeight: '500',
        lineHeight: '20px',
      },
    },
    signinBtn: {
      width: '100%',
      transition: 'none',
    },
    circularProgress: {
      marginLeft: 0,
      marginRight: theme.spacing(1),
      color: '#2b333f',
    },
    resetPass: {
      marginTop: '16px',
      color: '#00C8CD',
      fontFamily: 'Proxima-Nova-Regular',
      fontSize: '12px',
      lineHeight: '40px',
      textAlign: 'center',
      cursor: 'pointer',
    },
  }),
);
